import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // don't override if Authorization header is explicitly provided in the call
  if (config.headers?.Authorization) return config;
  // prefer admin token if present, else customer token
  const adminToken = localStorage.getItem('admin_token');
  const customerToken = localStorage.getItem('customer_token');
  if (adminToken) {
    config.headers.Authorization = `Bearer ${adminToken}`;
  } else if (customerToken) {
    config.headers.Authorization = `Bearer ${customerToken}`;
  }
  return config;
});

export default api;
